import { render } from "./MyInscriptions.vue?vue&type=template&id=4b68cfe2&scoped=true"
import script from "./MyInscriptions.vue?vue&type=script&lang=js"
export * from "./MyInscriptions.vue?vue&type=script&lang=js"

import "./MyInscriptions.vue?vue&type=style&index=0&id=4b68cfe2&scoped=true&lang=css"

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b68cfe2"]])

export default __exports__